import {
  BarChartCard,
  BarChartCardDataPoint,
  BlockListItemsCard,
  EmptyChartContent,
} from '@tinct/web-components';

interface DashboardChartsProps {
  chartData: BarChartCardDataPoint[];
  hasAnyVisits: boolean;
  isLoading: boolean;
}

export function DashboardCharts({chartData, hasAnyVisits, isLoading}: DashboardChartsProps) {
  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      <BarChartCard
        title="Visits last 30 days"
        description="On active campaigns"
        data={hasAnyVisits ? chartData : []}
        emptyState={
          !isLoading ? (
            <EmptyChartContent
              title="No Data yet"
              description="Your statistics, performance, and insights will be displayed here once your first campaign is active."
            />
          ) : undefined
        }
        emptyMessage={isLoading ? 'Loading...' : ''}
      />
      <BlockListItemsCard
        title="Recent activity"
        items={[]}
        emptyState={<EmptyChartContent
          title="No Data yet"
          description="Your statistics, performance, and insights will be displayed here once your first campaign is active."
        />}
      />
    </div>
  );
}
